import HeaderLayoutPresenter from "../components/header-layout/presenter/header-layout.js";

const headerElement = document.querySelector(`.header:not(.header_cart)`);

if (headerElement) {
  const headerLayoutComponent = new HeaderLayoutPresenter(headerElement);
  headerLayoutComponent.init();
}

